<template>
  <div>
    <div class="row row-inside">
      <div class="flex md12 mx-2">
        <va-button
          color="primary"
          icon="fa fa-plus"
          @click="createNewFormationModel()"
        >
          Nouveau modèle de formation
        </va-button>
      </div>
      <div class="flex md12 mx-2">
        <va-data-table
          class="va-table--hoverable va-table--stripped"
          :fields="fields"
          :data="listeModels"
          no-data-label="Aucun model de formation trouvé"
          :per-page="parseInt(perPage)"
        >
          <template #actions="{ rowData }">
            <va-button
              icon="fa fa-edit"
              color="info"
              @click.stop="openFormationModel(rowData)"
            />
            <va-button
              icon="fa fa-trash"
              color="danger"
              @click.stop="deleteFormationModel(rowData)"
            />
          </template>
        </va-data-table>
      </div>
    </div>
    <va-modal
      v-model="showDeleteModal"
      title="Supprimer le modèle de formation"
      okText="Supprimer"
      cancelText="Annuler"
      max-width="400px"
      v-on:ok="confirmDeleteModel"
      v-on:cancel="showDeleteModal = false"
    >
      <div class="modal-content">
        <h3>Supprimer le modèle</h3>
        <p>Êtes-vous sûr de vouloir supprimer ce modèle ?</p>
      </div>
    </va-modal>

    <add-formation-model
      v-model="showCreation"
      :idformation_types="idformation_types"
      @update="getListModels"
      @create="getListModels"
    />
  </div>
</template>

<script>
import axios from "axios";
import AddFormationModel from "./add-formation-model.vue";

export default {
  components: {
    "add-formation-model": AddFormationModel,
  },
  data() {
    return {
      perPage: 10,
      listeModels: [],
      showDeleteModal: false,
      modelToDelete: null,
      showCreation: false,
      idformation_types: null,
    }
  },
  mounted() {
    this.getListModels();
  },
  methods: {
    createNewFormationModel() {
      this.idformation_types = null;
      this.showCreation = true;
    },
    async deleteFormationModel(formationModel) {
      this.modelToDelete = formationModel;
      this.showDeleteModal = true;
    },
    async confirmDeleteModel() {
      try {
        await axios.delete("/api/afpf/formation-type", {
          params: { idformation_types: this.modelToDelete.idformation_types }
        });
        this.launchEpicmaxToast("Modèle de formation supprimé avec succès");
        this.getListModels();
      } catch (error) {
        if (error.response && error.response.status === 403) {
          this.launchEpicmaxToast("Ce modèle de formation est utilisé par une ou plusieurs formations et ne peut pas être supprimé.");
        } else {
          console.error(error);
          this.launchEpicmaxToast("Erreur lors de la suppression du modèle de formation");
        }

      } finally {
        this.showDeleteModal = false;
        this.modelToDelete = null;
      }
    },
    openFormationModel(formationModel) {
      this.idformation_types = formationModel.idformation_types;
      this.showCreation = true;

    },

    async getListModels() {
      try {
        let results = await axios.get("/api/afpf/formation-type");
        this.listeModels = results.data;
        this.idformation_types = null;
      } catch (error) {
        this.launchEpicmaxToast("Erreur lors de la récupération de la liste des modèles de formation");
      }
    },
    launchEpicmaxToast(toast) {
      this.showToast(toast, {
        position: "bottom-center",
        duration: 5000,
      });
    },
  },
  computed: {
    fields() {
      return [
        {
          name: "name",
          title: "Nom",
          sortField: "name"
        },
        {
          name: "shortname",
          title: "Nom court",
          sortField: "shortname"
        },
		{
          name: "description",
          title: "Description",
          sortField: "description"
        },
		{
          name: "docx_template_name_presence",
          title: "Modèle feuille de présence",
          sortField: "docx_template_name_presence"
        },
        {
          name: "niveau",
          title: "Niveau",
          sortField: "niveau"
        },
        {
          name: "validite_mois",
          title: "Validité (mois)",
          sortField: "validite_mois"
        },
        {
          name: "duree_tns",
          title: "Durée TNS (heures)",
          sortField: "duree_tns"
        },
        {
          name: "duree_salarie",
          title: "Durée Salarié (heures)",
          sortField: "duree_salarie"
        },
        {
          name: "__slot:actions",
          title: "Actions",
        },
      ]
    },
  },
}
</script>

<style>
</style>